import Component from './entry_history_table.vue'
export default Component
